import { cn } from "@/ui/utils/cn";

/**
 * The site's signature mark: a property's value rising over the years,
 * stepping up with each installment paid. Drawn once on load (respects
 * reduced-motion via global.css). SVG coordinates don't mirror under RTL,
 * so the line rises left-to-right in Arabic too, as a time axis should.
 */
export const ValueLine = ({
  className,
  animate = true,
}: {
  className?: string;
  animate?: boolean;
}) => (
  <svg
    viewBox="0 0 640 320"
    fill="none"
    aria-hidden="true"
    className={cn("h-auto w-full", className)}
    preserveAspectRatio="none"
  >
    <defs>
      <linearGradient id="value-fill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#A8E9CB" stopOpacity="0.45" />
        <stop offset="100%" stopColor="#A8E9CB" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path
      d="M0 300 C 60 296, 90 286, 130 270 S 200 238, 250 224 S 330 196, 380 160 S 470 110, 520 86 S 600 48, 640 40 L640 320 L0 320 Z"
      fill="url(#value-fill)"
    />
    <path
      d="M0 300 C 60 296, 90 286, 130 270 S 200 238, 250 224 S 330 196, 380 160 S 470 110, 520 86 S 600 48, 640 40"
      stroke="#A8E9CB"
      strokeWidth="3"
      strokeLinecap="round"
      pathLength={1}
      strokeDasharray={1}
      className={cn(animate && "animate-draw")}
      style={animate ? undefined : { strokeDashoffset: 0 }}
    />
  </svg>
);
